<template>
    <div class="report-filters">
        <div v-click-outside="closeFiltersBlock">

            <template v-if="this.$md.mobile() !== null">
                <div class="search-input-wrapper" v-show="isShowMobileSearch">
                    <input type="text" v-model="table_search_phrase" v-on:keyup.enter="useSearch">
                    <i class="mobile-search" @click="toggleMobileSearch"></i>
                </div>
                <div class="mobile-wrapper" v-show="!isShowMobileSearch">
                    <div class="mobile-filters-wrapper">
                        <i class="mobile-filters" @click="showFiltersBlock"></i>
                    </div>
                    <div class="label">
                        <!--<span v-if="getSiteFilterName !== null">Partner Report for {{getSiteFilterName}}</span>-->
                    </div>
                    <div class="mobile-search-wrapper">
                        <i class="mobile-search" @click="toggleMobileSearch"></i>
                    </div>
                </div>
            </template>

            <div class="filter-wrap">
                <div class="filter-button-wrap">
                  <span class="filter-button" @click="showFiltersBlock">
                      Filter
                      <i class="arrow-drop-down"></i>
                  </span>
                </div>
                <div class="filter-tags-wrapper" v-show="isShowExistedFilters()">

                    <CCFilterTag v-if="getFilterData('marketId').length"
                                 :options="getMarketsList()"
                                 :selectedOptions="getFilterData('marketId')"
                                 optionId="id"
                                 optionValue="name"
                                 :actionEvent="this.changeFilter.bind(this, 'marketId')"
                                 :removeEvent="this.changeFilter.bind(this, 'marketId')"
                                 headerLabel="Market"></CCFilterTag>

                    <CCFilterTag v-if="getFilterData('sourceId').length"
                                 :options="getSourcesList()"
                                 :selectedOptions="getFilterData('sourceId')"
                                 optionId="id"
                                 optionValue="company"
                                 :actionEvent="this.changeFilter.bind(this, 'sourceId')"
                                 :removeEvent="this.changeFilter.bind(this, 'sourceId')"
                                 headerLabel="Source"></CCFilterTag>

                    <CCFilterTag v-if="getFilterData('partnerId').length"
                                 :options="getPartnersList()"
                                 :selectedOptions="getFilterData('partnerId')"
                                 optionId="id"
                                 optionValue="company"
                                 :actionEvent="this.changeFilter.bind(this, 'partnerId')"
                                 :removeEvent="this.changeFilter.bind(this, 'partnerId')"
                                 headerLabel="Partner"></CCFilterTag>

                    <CCFilterTag v-if="getFilterData('deviceId').length"
                                 :options="getDevicesList()"
                                 :selectedOptions="getFilterData('deviceId')"
                                 optionId="id"
                                 optionValue="name"
                                 :actionEvent="this.changeFilter.bind(this, 'deviceId')"
                                 :removeEvent="this.changeFilter.bind(this, 'deviceId')"
                                 headerLabel="Device"></CCFilterTag>

                    <CCFilterTag v-if="getFilterData('networkId').length"
                                 :options="getNetworkList()"
                                 :selectedOptions="getFilterData('networkId')"
                                 optionId="id"
                                 optionValue="name"
                                 :actionEvent="this.changeFilter.bind(this, 'networkId')"
                                 :removeEvent="this.changeFilter.bind(this, 'networkId')"
                                 headerLabel="Network"></CCFilterTag>

                    <CCFilterTag v-if="getFilterData('siteGroupId').length"
                                 :options="getSiteGroupsList()"
                                 :selectedOptions="getFilterData('siteGroupId')"
                                 optionId="id"
                                 optionValue="name"
                                 :actionEvent="this.changeFilter.bind(this, 'siteGroupId')"
                                 :removeEvent="this.changeFilter.bind(this, 'siteGroupId')"
                                 headerLabel="Site Group"></CCFilterTag>

                    <CCFilterTag v-if="getFilterData('siteId').length"
                                 :options="getSitesList()"
                                 :selectedOptions="getFilterData('siteId')"
                                 optionId="id"
                                 optionValue="name"
                                 :actionEvent="this.changeFilter.bind(this, 'siteId')"
                                 :removeEvent="this.changeFilter.bind(this, 'siteId')"
                                 headerLabel="Site"></CCFilterTag>

                    <CCFilterTagInput v-if="advancedFilters.campaignName != ''"
                                    :value="advancedFilters.campaignName + ''"
                                    :actionEvent="this.modifyAdvancedFilter.bind(this, 'campaignName')"
                                    :removeEvent="this.modifyAdvancedFilter.bind(this, 'campaignName')"
                                    fieldName="campaignName"
                                    headerLabel="Campaign"/>

                    <CCFilterTagInput v-if="advancedFilters.adGroupName != ''"
                                    :value="advancedFilters.adGroupName + ''"
                                    :actionEvent="this.modifyAdvancedFilter.bind(this, 'adGroupName')"
                                    :removeEvent="this.modifyAdvancedFilter.bind(this, 'adGroupName')"
                                    fieldName="adGroupName"
                                    headerLabel="Adgroup"/>

                    <CCFilterTagInput v-if="showHoursTag"
                                    :value="advancedFilters.hours"
                                    :actionEvent="this.modifyAdvancedFilter.bind(this, 'hours')"
                                    :removeEvent="hideHoursTag"
                                    fieldName="hours"
                                    headerLabel="Hours"
                                    multiple/>

                </div>
                <template v-if="!$md.mobile()">
                    <CCCalendar :actionEvent="this.setDateRanges" :namespace="namespace" :dates="dates"></CCCalendar>
                </template>
            </div>
            <div class="filtersList" v-show="isShowFiltersBlock">
                <div v-show="isShowFiltersBlock" class="filters-wrapper">
                    <template v-if="$md.mobile() !== null">
                        <div class="mobile-actions-wrapper" v-bind:style="{'top': scrollOffsetY + 'px'}">
                  <span @click="clearFilters">
                    <i class="close-form"></i>
                  </span>
                            <span>Choose Filters</span>
                            <span @click="applyFilters">Save</span>
                        </div>
                    </template>
                    <div class="filtersBlock">
                        <div class="filter-block-wrapper">
                            <CCFilterSelect :options="getMarketsList()"
                                            :selectedOptions="getFilterData('marketId')"
                                            optionId="id"
                                            optionValue="name"
                                            :actionEvent="this.updateFilter.bind(this, 'marketId')"
                                            :removeEvent="this.changeFilter.bind(this, 'marketId')"
                                            headerLabel="Market"></CCFilterSelect>
                        </div>
                        <div class="filter-block-wrapper">
                            <CCFilterSelect :options="getSourcesList()"
                                            :selectedOptions="getFilterData('sourceId')"
                                            optionId="id"
                                            optionValue="company"
                                            :actionEvent="this.updateFilter.bind(this, 'sourceId')"
                                            :removeEvent="this.changeFilter.bind(this, 'sourceId')"
                                            headerLabel="Source"></CCFilterSelect>
                        </div>
                        <div class="filter-block-wrapper">
                            <CCFilterSelect :options="getPartnersList()"
                                            :selectedOptions="getFilterData('partnerId')"
                                            optionId="id"
                                            optionValue="company"
                                            :actionEvent="this.updateFilter.bind(this, 'partnerId')"
                                            :removeEvent="this.changeFilter.bind(this, 'partnerId')"
                                            headerLabel="Partner"></CCFilterSelect>
                        </div>
                        <div class="filter-block-wrapper">
                            <CCFilterSelect :options="getDevicesList()"
                                            :selectedOptions="getFilterData('deviceId')"
                                            optionId="id"
                                            optionValue="name"
                                            :actionEvent="this.updateFilter.bind(this, 'deviceId')"
                                            :removeEvent="this.changeFilter.bind(this, 'deviceId')"
                                            headerLabel="Device"></CCFilterSelect>
                        </div>
                        <div class="filter-block-wrapper">
                            <CCFilterSelect :options="getNetworkList()"
                                            :selectedOptions="getFilterData('networkId')"
                                            optionId="id"
                                            optionValue="name"
                                            :actionEvent="this.updateFilter.bind(this, 'networkId')"
                                            :removeEvent="this.changeFilter.bind(this, 'networkId')"
                                            headerLabel="Network"></CCFilterSelect>
                        </div>
                        <div class="filter-block-wrapper">
                            <CCFilterSelect :options="getSiteGroupsList()"
                                            :selectedOptions="getFilterData('siteGroupId')"
                                            optionId="id"
                                            optionValue="name"
                                            :actionEvent="this.updateFilter.bind(this, 'siteGroupId')"
                                            :removeEvent="this.changeFilter.bind(this, 'siteGroupId')"
                                            headerLabel="Site Groups"></CCFilterSelect>
                        </div>
                        <div class="filter-block-wrapper">
                            <CCFilterSelect :options="getSitesList()"
                                            :selectedOptions="getFilterData('siteId')"
                                            optionId="id"
                                            optionValue="name"
                                            :actionEvent="this.updateFilter.bind(this, 'siteId')"
                                            :removeEvent="this.changeFilter.bind(this, 'siteId')"
                                            headerLabel="Site"></CCFilterSelect>
                        </div>
                    </div>

                    <div class="advanced-filters-toggle" v-bind:class="{'open': showAdvancedFiltersBlock}" @click="toggleAdvancedFiltersBlock">
                    <span>
                        Advanced Filter
                        <i class="advanced-filter-icon-toggle" v-bind:class="{'open': showAdvancedFiltersBlock}"></i>
                    </span>
              </div>
              <transition name="fade">
                <div class="advanced-filters-wrapper" v-show="showAdvancedFiltersBlock">                  
                  <div class="block-wrapper">
                    <div>
                      Campaign
                      <div>
                          <input type="text" v-model="advancedFilters.campaignName" class="input-text-long">
                      </div>
                    </div>
                    <div>
                      Adgroup
                      <div>
                          <input type="text" v-model="advancedFilters.adGroupName" class="input-text-long">
                      </div>
                    </div>
                  </div>
                  <div class="block-wrapper">                    
                    <div>
                      Hours
                      <div>
                        <input type="text" class="advanced-hours" v-model="advancedFilters.hours.min" >
                        -
                        <input type="text" class="advanced-hours" v-model="advancedFilters.hours.max">
                      </div>
                    </div>
                  </div>
                </div>
              </transition>


                    <template v-if="this.$md.mobile() === null">
                        <div class="filters-bottom-wrapper">
                            <div>
                                <button @click="clearFilters()">Cancel</button>
                                <button class="apply-button" @click="applyFilters()">Apply</button>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import CCFilterSelect from '@/components/common/CCFilterSelect';
    import CCFilterTag from '@/components/common/CCFilterTag';
    import CCFilterTagInput from '@/components/common/CCFilterTagInput';
    import CCCalendar from '@/components/common/CCCalendar';
    import CCSwitchToggle from '@/components/common/CCSwitchToggle';
    import CCSelect from '@/components/common/CCSelect';
    import BaseReportFiltersMixin from '@/components/mixins/baseReportFiltersMixin';
    import reportMixin from '@/components/mixins/scrubRateHourlyReportMixin';

    export default {
        name: "cc-scrubrate-hourly-report-filters",
        components: {
            CCFilterSelect,
            CCFilterTag,
            CCFilterTagInput,
            CCCalendar,
            CCSwitchToggle,
            CCSelect
        },
        mixins: [
            BaseReportFiltersMixin,
            reportMixin
        ],
        props: {
            namespace: {
                type: String,
                required: true
            }
        },
        data(){
            return {
                showHoursTag: false,
                advancedFilters: {
                    campaignName: '',
                    adGroupName: '',
                    hours: {
                        min: '00:00',
                        max: '24:00'
                    }
                },
                dates: {
                    startDate: null,
                    endDate: null,
                    startDateB: null,
                    endDateB: null
                }
            }
        },
        watch: {
            advancedFilters : {
                handler: function(obj) {
                    for(let field in obj ) {
                        if( ! obj.hasOwnProperty(field) ) continue;
                        let value = obj[field];
                    
                        switch(field) {
                            case 'adGroupName':
                            case 'campaignName':
                                value = value === null ? '' : value;
                                break;

                            case 'hours':
                                let min = parseInt(value.min);
                                let max = parseInt(value.max);
                                if( isNaN(min) ) min = 0;  if( min < 0 ) min = 0; if( min > 24 ) min = 24;
                                if( isNaN(max) ) max = 24; if( max < 0 ) max = 0; if( max > 24 ) max = 24;

                                if( max < 10 ) max = '0' + max;
                                if( min < 10 ) min = '0' + min;

                                value.max = max + ':00'; value.min = min + ':00';
                                if( this.$el.getRootNode().activeElement  ) {
                                    let elem = this.$el.getRootNode().activeElement;                                    
                                    if( elem.setSelectionRange && elem.className === 'advanced-hours' ) {
                                        this.$nextTick(()=> elem.setSelectionRange(2, 2));
                                    }
                                }
                                break;
                        }

                        this.advancedFilters[field] = value;                        
                    }

                    if( this.advancedFilters.hours.min != '00:00' || this.advancedFilters.hours.max != '24:00' ) {
                        this.showHoursTag = true;
                    }
                },
                deep: true
            }            
        },
        mounted() {
            let filters = this.$store.getters[this.namespace + '/getFilters'];
            if( filters.hasOwnProperty('advancedFilters') ) {
                let advancedFilters = filters['advancedFilters'];
                for(let key in advancedFilters ) {
                    if( ! advancedFilters.hasOwnProperty(key) ) continue;
                    this.advancedFilters[key] = advancedFilters[key];
                }
            }            
        },
        computed: {
            scrollOffsetY: function(){
                return this.$store.getters.getScrollOffsetY;
            },
        },
        methods: {
            hideHoursTag(value) {    
                this.modifyAdvancedFilter('hours', value)
                this.showHoursTag = false;
            },
            modifyAdvancedFilter: function(field, value) {                                
                this.advancedFilters[field] = value; 
                this.changeAdvancedFilter(field, value);               
            },
            checkFilters: function() {
                return true;
            },
            isShowExistedFilters: function () {
                return true;
                // let filtersList = this.$store.getters[this.namespace + '/getFilters'];
                // let filters = filtersList.filters;

                // return (
                //     (filters.siteId && filters.siteId.length) || (filters.partnerId && filters.partnerId.length) ||
                //     (filters.sourceId && filters.sourceId.length) || (filters.marketId && filters.marketId.length) ||
                //     (filters.deviceId && filters.deviceId.length) || (filters.siteGroupId && filters.siteGroupId.length) ||
                //     (filters.networkId && filters.networkId.length)
                // );
            }
        }
    }
</script>

<style lang="scss" scoped>

    .filters-wrapper {
        border: 1px solid $border-color;
        border-radius: $border-radius;
        box-shadow: 1px 3px 7px 1px #cbcccd;
    }

    .advanced-filters-toggle {
        padding-bottom: 15px;
        border-bottom: 1px solid $border-color;

        &.open {
            border-bottom: 0;
        }

        & > span {
            cursor: pointer;
        }

        .advanced-filter-icon-toggle {
            display: inline-block;
            width: 0.65em;
            height: 0.65em;
            margin-right: 5px;
            margin-left: 5px;
            background-image: url('/static/img/icon-toggle-bottom.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;

            &.open {
                background-image: url('/static/img/icon-toggle-top.svg');
            }
        }
    }

    .advanced-filters-wrapper {
        display: grid;
        grid-template-columns: repeat(2, 1fr);

        & > div.block-wrapper {
            padding: 25px;
            text-align: left;
            border: 1px solid $border-color;
            border-radius: $border-radius;
            border-right: 0;

            & > div {
                text-align: left;
                margin-top: 25px;
                margin-bottom: 25px;

                & > div {
                    margin-top: 10px;

                    & > input {
                        max-width: 75px;
                        padding: 7px 5px 7px 0;
                        border: 1px solid $border-color;
                        border-radius: 3px;
                        text-indent: 5px;
                        text-align: center;

                        &.input-text-long {
                            max-width: 100%;
                            width: 100%;
                            text-align: left;
                        }
                    }
                }
            }

            & > div:first-child {
                margin-top: 0;
            }

            & > div:last-child {
                margin-bottom: 0;
            }

            & > .select-wrapper {
                text-align: center;

                & > div {
                    margin-top: 15px;

                    & > select {
                        min-width: 50%;
                    }
                }
            }

        }

        & > div:first-child {
            border-left: 0;
        }
    }

    .filters-bottom-wrapper {
        text-align: right;
        margin-right: 25px;
        padding: 10px 0 10px 0;

        & > div > button {
            background-color: #fff;
            color: #676767;
            padding: 10px 25px;
            border: 1px solid $border-color;
            border-radius: 3px;

            &.apply-button {
                color: #fff;
                background-color: #4a90e2;
                border: 1px solid #3376c5;
                cursor: pointer;
            }

        }

        & > div > button:first-child {
            margin-right: 15px;
        }
    }

    .report-filters {
        margin-bottom: 10px;
        width: 100%;
    }

    .filter-wrap {
        display: grid;
        grid-template-columns: 90px 5fr auto;
    }

    .filter-tags-wrapper {
        text-align: left;
    }

    .filter-button-wrap {
        text-align: left;

        .filter-button {
            display: inline-block;
            padding: 5px 8px;
            color: #797979;
            font-size: 14px;
            background-color: #fff;
            border: 1px solid $border-color;
            border-radius: 3px;
            cursor: pointer;

            & > .arrow-drop-down {
                display: inline-block;
                width: 0.65em;
                height: 0.65em;
                margin-right: 5px;
                margin-left: 5px;
                background-image: url('/static/img/icon-filter-dropdown.svg');
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
            }
        }
    }


    .filtersList {
        position: absolute;
        z-index: 999;
        background-color: #fff;
    }

    .filtersBlock {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 20px;
        padding: 15px;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    @include desktop-and-below {
        .filtersBlock {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    @include tablet-landscape-and-below {
        .filtersBlock {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @include mobile-only {

        .filtersList {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            display: block;
            margin-right: 0;
            z-index: 10;
            width: 100vw;
        }

        .mobile-actions-wrapper {
            padding-top: 15px;
            background-color: #4a90e2;
            padding-bottom: 15px;
            font-size: 1rem;
            display: flex;
            justify-content: space-between;
            align-items: end;
            position: sticky;
            z-index: 999;

            & > span {
                color: #fff;
            }

            & > span > i.close-form {
                display: inline-block;
                width: 1.15em;
                height: 1.15em;
                background-image: url('/static/img/icon-close.svg');
                background-repeat: no-repeat;
                background-position: left center;
                background-size: contain;
            }

            & > span:first-child {
                margin-left: 15px;
            }

            & > span:last-child {
                margin-right: 15px;
            }
        }

        .filters-wrapper {
            border: 0;
        }

        .advanced-filters-wrapper {
            grid-template-columns: auto;

            & > div.block-wrapper {
                padding: 5px;
                margin-right: 5px;
                margin-left: 5px;
                border: 0;

                & > div {
                    display: flex;
                    flex-wrap: nowrap;
                    flex-direction: row;
                    align-items: baseline;
                    justify-content: space-between;

                    & > div {
                        margin-top: 0;
                    }
                }
            }
        }

        .advanced-filters-toggle {
            border-bottom: 0;
        }

        .filtersBlock {
            grid-template-columns: 1fr;
            padding-top: 15px;
            padding-left: 4px;
            padding-right: 5px;
            grid-gap: 10px;
        }

        .filter-button-wrap {
            display: none;
        }

        .filter-tags-wrapper {
            display: none;
        }

        .report-filters {
            margin-top: 15px;
            margin-bottom: 15px;
        }

        .mobile-wrapper {
            display: grid;
            grid-template-columns: 45px auto 45px;

            & > .label {
                margin: auto 0;
                max-width: 70vw;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                & > span {
                    font-size: 16px;
                }
            }
        }

        .mobile-filters {
            display: inline-block;
            width: 1.25em;
            height: 1.25em;
            margin-right: 5px;
            margin-left: 5px;
            background-image: url('/static/img/icon-mobile-filters.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }

        .mobile-search {
            display: inline-block;
            width: 1.5em;
            height: 1.5em;
            margin-right: 5px;
            margin-left: 5px;
            background-image: url('/static/img/filters-search-icon.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }

        .search-input-wrapper {
            display: grid;
            grid-template-columns: 1fr auto;
            margin-left: 15px;
            margin-right: 15px;

            & > input {
                margin-right: 20px;
                border: 1px solid $border-color;
                border-radius: 5px;
                text-indent: 1em;
                padding: 3px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/reports/scrubRateHourlyReport/CCScrubRateHourlyReportFilters.vue